// extracted by mini-css-extract-plugin
export default {"sidebarContainer":"index-module__sidebarContainer--Uu0se"};